import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';
import { Link } from 'react-router';

import ListView from '../Common/ListView.react';
import { ListItem } from 'material-ui/List';

import CertificateIcon from 'material-ui/svg-icons/action/verified-user';
import CertificateActions from '../../actions/CertificateActionCreator';
import CertificateStore from '../../stores/CertificateStore';
import { statusColours } from '../../constants/ColourConstants';

const style = {
    listItem: {
        padding: '2px',
    },
    icon: {
        height: '32px',
        width: '32px',
    }
};

const CertificateListItem = ({data}) => {
    const infoLink = `/dashboard/certificate/${data.id}`;
    return (
        <ListItem
            leftAvatar={(
                <Link to={infoLink}>
                    <CertificateIcon
                        style={style.icon}
                        color={statusColours.primary}
                    />
                </Link>)}
            primaryText={<Link to={infoLink} className="primaryText">{data.name}</Link>}
            secondaryText={(
                <Link to={infoLink} className="secondaryText">
                    {data.paperSize && `${data.paperSize}`}<br/>
                    {data.authority || ''}
                </Link>
            )}
            secondaryTextLines={2}
        />
    );
};

CertificateListItem.propTypes = {
    data: PropTypes.shape({
        id:     PropTypes.number.isRequired,
        name:   PropTypes.string.isRequired,
        fieldCount: PropTypes.number,
        authority: PropTypes.string,
    }).isRequired
};

class CertificateList extends Component {
    componentDidMount() {
        CertificateActions.getAll();
    }

    render() {
        return (
            <ListView
                title="Certificates"
                items={this.state.certificates}
                itemDecorator={CertificateListItem}
                newEntityUrl={this.context.auth.isAdmin() ? '/dashboard/certificate/new' : ''}
            />
        );
    }
}

CertificateList.getStores = () => ([CertificateStore]);
CertificateList.calculateState = (prevState) => ({
    isFetching:     CertificateStore.isFetching(),
    certificates:   CertificateStore.getAll()
});

CertificateList.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default Container.create(CertificateList);
